import useLocale from 'next-translate/useTranslation';
import React from 'react';

import { VideoModelChipsMarquee } from './VideoHero';

const HIGHLIGHTS = [
  ['20+', 'video models'],
  ['4K', 'max resolution'],
  ['15s', 'per generation'],
  ['🔊', 'native audio'],
];

const VideoModelsBand = () => {
  const { t } = useLocale('ai-videos');

  return (
    <section
      id='models'
      className='relative border-y border-white/[0.06] bg-white/[0.02] py-16 lg:py-20'
    >
      <div className='mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8'>
        <h2 className='text-3xl font-extrabold tracking-tight text-white md:text-4xl'>
          {t('Every top video model. One subscription.')}
        </h2>
        <p className='mx-auto mt-4 max-w-2xl text-lg text-slate-400'>
          {t(
            'Seedance 2.0, Veo 3.1, Kling 3.0, MiniMax H3 and more — pick per shot, or let us choose the best fit.',
          )}
        </p>
      </div>
      <div className='mt-10'>
        <VideoModelChipsMarquee />
      </div>
      <div className='mx-auto mt-12 grid max-w-4xl grid-cols-2 gap-8 px-4 sm:px-6 md:grid-cols-4'>
        {HIGHLIGHTS.map(([value, label]) => (
          <div key={label} className='text-center'>
            <div className='text-3xl font-extrabold tracking-tight text-white md:text-4xl'>
              {value}
            </div>
            <div className='mt-1 text-sm text-slate-400'>{t(label)}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default VideoModelsBand;
